// extracted by mini-css-extract-plugin
export var dateLabel = "_3d-0";
export var dateLabelError = "_3d-1";
export var fullWidth = "_3d-2";
export var smaller = "_3d-3";